import React, { useEffect, useState } from "react";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import axios from "axios";
import { Link } from "react-router-dom";
import { Container, Row, Col, Breadcrumb, Tab, Tabs } from "react-bootstrap";
import bannerImage from "../../Images/programs/diploma.webp";
import EnquiryNow from "../common/EnquiryNow";

const DiplomaProgrammes = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [modalShow2, setModalShow2] = useState(false);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await axios.get(
          "https://isbmuniversity.edu.in/admin-portal/level-courses/Diploma"
        );

        const coursesData = response.data?.courses;

        if (Array.isArray(coursesData)) {
          setCourses(coursesData);
        } else {
          setError("No courses found.");
          setCourses([]);
        }
      } catch (error) {
        console.error("Error fetching courses:", error);
        setError("Failed to load courses.");
        setCourses([]);
      } finally {
        setLoading(false);
      }
    };

    fetchCourses();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <React.Fragment>
      <title>Diploma Programs | Build Practical Skills & Grow Career</title>
      <meta
        name="description"
        content="Explore ISBM University's wide range of diploma courses in fields like Business, Engineering, and Health Sciences. Enhance your skills & career prospects. Apply now."
      />
      <Topnav />
      <section
        className="section-hero-banner ptb-50"
        style={{
          backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(77, 77, 77, 0.8)), url(${bannerImage})`,
        }}
      >
        <div className="banner-hero-overlay">
          <div className="container-xxl">
            <div className="section-hero-content">
              <h1>Career-Focused Diploma Programs</h1>
              <ol className="breadcrumb mt-3 text-center mb-0">
                <li className="breadcrumb-item">
                  <Link
                    to="/"
                    style={{ color: "#fff", textDecoration: "none" }}
                  >
                    Home
                  </Link>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  Diploma Programmes
                </li>
                <hr className="section-divider" />
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="ptb-50 text-center">
        <div className="container">
          <h2 className="modern-title section-title text-blue text-center">
            Explore Career-Focused Diploma Programs at ISBM University
          </h2>
          <p>
            At ISBM University, we offer a diverse range of diploma programs
            designed to equip students with industry-relevant skills and
            practical knowledge. Our diploma courses span various fields
            including Business Management, Computer Applications, Education,
            Engineering, and Health Sciences—each curated to meet current job
            market demands. Whether you're looking to launch your career,
            upskill, or switch fields, our flexible and career-oriented diplomas
            serve as a strong foundation for your professional journey.
          </p>
          <p>
            Our programs emphasize hands-on learning, real-world application,
            and personalized academic support. Students benefit from a
            curriculum developed by experienced faculty and industry
            professionals, ensuring that the content remains current and
            impactful. We offer both on-campus and online learning options,
            making education accessible regardless of your location or schedule.
          </p>
          <p>
            Join a dynamic community of learners and take the next step toward
            your goals with ISBM University's diploma programs. With a focus on
            excellence, innovation, and employability, we are committed to
            helping you build a future filled with opportunity and success.
          </p>
        </div>
      </section>

      <section className="pb-50">
        <div className="container-xxl">
          <Row>
            <Col lg={12}>
              <div className="text-center mb-5">
                <h2 className="text-blue section-title modern-title">
                  Discover Our Courses
                </h2>
                <p className="lead">In-demand courses across industries</p>
              </div>
              <div className="row row-cols-1 row-cols-md-3 g-4">
                {Array.isArray(courses) && courses.length > 0 ? (
                  courses.map((course) => (
                    <div key={course.id} className="col p-2">
                      <div className="card rounded-3 courseBox p-0 h-100 shadow-lg bg-body border-0">
                        <div className="card-header">
                          <Link
                            to={`/course-details/${encodeURIComponent(
                              course.name
                            )}`}
                            className="text-decoration-none"
                          >
                            <h3 className="card-title font-weight-bold m-0">
                              {course.title}
                            </h3>
                          </Link>
                        </div>
                        <div className="card-body">
                          <div className="col">
                            <Row className="info-line">
                              <i className="ti ti-file-spark me-2 align-self-center"></i>
                              <p>{course.level}</p>
                            </Row>
                            <Row className="info-line">
                              <i className="ti ti-file-report me-2 align-self-center"></i>
                              <p>{course.duration}</p>
                            </Row>
                            <Row className="info-line">
                              <i className="ti ti-file-text-shield me-2 align-self-center col-auto"></i>
                              <p className="col-11">{course.eligibility}</p>
                            </Row>
                          </div>
                          <div className="d-flex flex-wrap mt-auto">
                            <button
                              type="button"
                              class="btn btn-sm btn-download px-5 me-2"
                              onClick={() => setModalShow2(true)}
                            >
                              Apply Now
                            </button>
                            <EnquiryNow
                              show={modalShow2}
                              onHide={() => setModalShow2(false)}
                            />
                            <Link
                              className="btn btn-sm btn-apply"
                              to={`/course-details/${encodeURIComponent(
                                course.name
                              )}`}
                            >
                              <span className="gdlr-core-content">
                                View Details
                              </span>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <p>No courses available.</p>
                )}
              </div>
            </Col>
          </Row>
        </div>
      </section>

      <Footer />
    </React.Fragment>
  );
};

export default DiplomaProgrammes;
